import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import type { BillingIdentity } from "@/components/settings/BillingIdentityModal";

export function useBillingIdentity(orgId: string | null) {
  const [identity, setIdentity] = useState<BillingIdentity | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!orgId) return;
    let cancelled = false;
    setIdentity(null);
    setLoaded(false);
    (async () => {
      try {
        const { data } = await supabase
          .from("organizations")
          .select("billing_first_name, billing_last_name, billing_id_type, billing_id_number, billing_phone")
          .eq("id", orgId)
          .maybeSingle();
        if (cancelled) return;
        if (data?.billing_id_number) {
          setIdentity({
            billing_first_name: data.billing_first_name ?? "",
            billing_last_name: data.billing_last_name ?? "",
            billing_id_type: (data.billing_id_type as BillingIdentity["billing_id_type"]) ?? "CC",
            billing_id_number: data.billing_id_number,
            billing_phone: data.billing_phone ?? null,
          });
        }
      } catch (err) {
        console.error("[useBillingIdentity] fetch error:", err);
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
  }, [orgId]);

  return { identity, setIdentity, loaded };
}
